import React from 'react';
import { useNavigate } from 'react-router-dom';
import { rutaDetalleTramite } from '../../utils/rutasTramite';

/**
 * Panel genérico "Trámites relacionados del cliente": muestra trámites de OTRO módulo
 * que cuelgan del mismo cliente (detectados por CUIL, no por FK). Se usa hoy entre
 * Jubilación <-> Plan de Pago 27.705, pero no asume el tipo: solo pinta lo que le llega.
 */
export default function PanelTramitesRelacionados({ titulo, icono = 'bi-link-45deg', tramites, cargando, textoVacio, accion }) {
    const navigate = useNavigate();
    const lista = Array.isArray(tramites) ? tramites : [];

    if (!cargando && lista.length === 0 && !textoVacio) return null;

    return (
        <div className="row g-4 mt-1">
            <div className="col-12">
                <div className="card shadow-lg border-0 rounded-4 p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <h4 className="fw-bold text-primary mb-0">
                            <i className={`bi ${icono} me-2`}></i>{titulo}
                        </h4>
                        {accion}
                    </div>

                    {cargando ? (
                        <div className="text-center py-3">
                            <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                        </div>
                    ) : lista.length === 0 ? (
                        <p className="text-muted fst-italic mb-0">{textoVacio}</p>
                    ) : (
                        <div className="row g-3">
                            {lista.map((t) => (
                                <div key={t.idTramite} className="col-md-6">
                                    <div
                                        className="rounded-4 p-3 h-100 shadow-sm d-flex justify-content-between align-items-center gap-2"
                                        style={{ background: '#f8fafc', cursor: 'pointer', transition: 'all 0.2s ease' }}
                                        onClick={() => navigate(rutaDetalleTramite(t))}
                                        onMouseEnter={(e) => { e.currentTarget.style.background = '#eff6ff'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.background = '#f8fafc'; }}
                                    >
                                        <div style={{ minWidth: 0 }}>
                                            <h6 className="fw-bold text-primary mb-1 text-truncate">
                                                {t.tipoTramite?.nombre || 'Trámite'}
                                            </h6>
                                            <span className="badge bg-success bg-opacity-10 text-success border border-success-subtle rounded-pill">
                                                {t.nombreEstadoActual || 'Ingreso del Trámite'}
                                            </span>
                                        </div>
                                        <span className="text-primary fw-semibold small text-nowrap">
                                            Ver <i className="bi bi-arrow-right ms-1"></i>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
